import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="logins-hubs"
export default class extends Controller {
  static values = {
    url: String,
    current: String,
    errorMessage: String,
  }

  static targets = ["select"]

  declare urlValue: string
  declare currentValue: string
  declare errorMessageValue: string
  declare selectTarget: HTMLSelectElement

  async connect() {
    this.selectTarget.disabled = true

    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
      })

      if (!response.ok)
        return this.setErrorMessage(this.errorMessageValue);

      const hubs: Array<{ id: string; name: string }> = await response.json()

      this.selectTarget.innerHTML = ""

      const blank = document.createElement("option")
      blank.value = ""
      blank.textContent = "-"
      this.selectTarget.appendChild(blank)

      for (const hub of hubs) {
        const option = document.createElement("option")
        option.value = hub.id
        option.textContent = hub.name
        if (hub.id.toString() === this.currentValue) option.selected = true
        this.selectTarget.appendChild(option)
      }
      this.selectTarget.disabled = false
    } catch (e) {
      this.setErrorMessage(this.errorMessageValue);
    }
  }

  private setErrorMessage(error: string) {
    this.selectTarget.innerHTML = ""
    const option = document.createElement("option")
    option.value = ""
    option.textContent = error
    this.selectTarget.appendChild(option)
  }
}
